  import React, { useState } from 'react';
  import { Tabs } from 'antd';
import Banks from './components/banks';
import Limits from './components/limits';
import Comments from './components/comments';

  function Ustawienia() {
    const onChange = (key) => {
      console.log(key);
    };

    const items = [
      {
        key: '1',
        label: 'Rachunki bankowe',
        children: <Banks />,
      },
      {
        key: '2',
        label: 'Limity prowizji',
        children: <Limits />,
      },
      {
        key: '3',
        label: 'Fragmenty komentarzy',
        children: <Comments />,
      },
    ];

    return (
    <div style={{padding: '24px'}}>
      <Tabs
        className='gapped'
        defaultActiveKey="1"
        items={items}
        onChange={onChange}
      />
    </div>
    );
  }

  export default Ustawienia;
